const formatRelativeTime = (date: Date) => {
  const msPerMinute = 60 * 1000;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30;
  const msPerYear = msPerDay * 365;

  const current = new Date();

  const elapsed = date.getTime() - current.getTime();
  const isFuture = elapsed > 0;

  const absElapsed = Math.abs(elapsed);

  if (!isFuture && absElapsed < 5000) {
    return 'just now';
  } else if (absElapsed < msPerMinute) {
    return isFuture
      ? `in ${Math.round(absElapsed / 1000)} second${Math.round(absElapsed / 1000) === 1 ? '' : 's'}`
      : `${Math.round(absElapsed / 1000)} second${Math.round(absElapsed / 1000) === 1 ? '' : 's'} ago`;
  } else if (absElapsed < msPerHour) {
    return isFuture
      ? `in ${Math.round(absElapsed / msPerMinute)} minute${Math.round(absElapsed / msPerMinute) === 1 ? '' : 's'}`
      : `${Math.round(absElapsed / msPerMinute)} minute${Math.round(absElapsed / msPerMinute) === 1 ? '' : 's'} ago`;
  } else if (absElapsed < msPerDay) {
    return isFuture
      ? `in ${Math.round(absElapsed / msPerHour)} hour${Math.round(absElapsed / msPerHour) === 1 ? '' : 's'}`
      : `${Math.round(absElapsed / msPerHour)} hour${Math.round(absElapsed / msPerHour) === 1 ? '' : 's'} ago`;
  } else if (absElapsed < msPerMonth) {
    return isFuture
      ? `in ${Math.round(absElapsed / msPerDay)} day${Math.round(absElapsed / msPerDay) === 1 ? '' : 's'}`
      : `${Math.round(absElapsed / msPerDay)} day${Math.round(absElapsed / msPerDay) === 1 ? '' : 's'} ago`;
  } else if (absElapsed < msPerYear) {
    return isFuture
      ? `in ${Math.round(absElapsed / msPerMonth)} month${Math.round(absElapsed / msPerMonth) === 1 ? '' : 's'}`
      : `${Math.round(absElapsed / msPerMonth)} month${Math.round(absElapsed / msPerMonth) === 1 ? '' : 's'} ago`;
  } else {
    return isFuture
      ? `in ${Math.round(absElapsed / msPerYear)} year${Math.round(absElapsed / msPerYear) === 1 ? '' : 's'}`
      : `${Math.round(absElapsed / msPerYear)} year${Math.round(absElapsed / msPerYear) === 1 ? '' : 's'} ago`;
  }
};

export default formatRelativeTime;
